// Read the eight tracking params from a query string. Missing params return
// empty string (never null) so payload shape is stable.
export function readUTMs(search) {
  var s = typeof search === 'string' ? search : (typeof location !== 'undefined' ? location.search : '');
  var p;
  try { p = new URLSearchParams(s); } catch (e) { p = null; }
  function g(k) { return (p && p.get(k)) || ''; }
  return {
    utm_source: g('utm_source'),
    utm_medium: g('utm_medium'),
    utm_campaign: g('utm_campaign'),
    utm_term: g('utm_term'),
    utm_content: g('utm_content'),
    gclid: g('gclid'),
    fbclid: g('fbclid'),
    msclkid: g('msclkid')
  };
}
